module.exports = __webpack_public_path__ + "9dd5b819a8afaa88e729930228711b00.png";